import React from 'react';
import TcgMeLogo from './TcgMeLogo';
import './TcgMePage.css';

const TcgMePage = () => {

  return (
    <div className="tcgme-page">
        
        <div className="tcgme-hero">
          <TcgMeLogo className="tcgme-logo" />
          <div className="hero-visual">
            <div className="card-preview">
              <div className="card-background">
                <div className="card-content">
                  <div className="card-name">Starry Pizza</div>
                  <div className="card-image">
                    <img src="/projects/tcgme/CardExample.png" alt="TcgMe Card Example" />
                  </div>
                  <div className="card-caption">
                    A star-shaped pizza with a...
                  </div>
                  <div className="card-footer">
                    <div className="card-date">2025-08-15</div>
                    <div className="card-logo">
                      <TcgMeLogo />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Project Overview */}
        <div className="project-section">
          <h2>About TcgMe</h2>
          <p>
            TcgMe is a collectible card app that transforms your photos into unique, AI-generated trading cards. 
            Inspired by the Pokemon Company's PocketTCG app, I created this with a user-focused design approach.
          </p>
          <p>
            The app uses the users own camera roll and the chatGPT API to generate the cards for the user to collect.
          </p>
          <div className="demo-video">
            <video autoPlay loop muted playsInline>
              <source src="/projects/tcgme/MainScreen.mp4" type="video/mp4" />
            </video>
          </div>
        </div>

        {/* Technology Stack */}
        <div className="tech-section">
          <h2>Technologies Used</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">⚛️</div>
              <span>React</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🟨</div>
              <span>JavaScript</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🤖</div>
              <span>OpenAI API</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🔷</div>
              <span>.NET</span>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="features-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h3>AI Card Generation</h3>
              <p>Open packs based on your camera roll!</p>
              <div className="feature-demo">
                <video autoPlay loop muted playsInline>
                  <source src="/projects/tcgme/Collection Screen.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎬</div>
              <h3>Lottie Animations</h3>
              <p>Custom animations created with Adobe After Effects for the navigation menu</p>
              <div className="feature-demo">
                <video autoPlay loop muted playsInline>
                  <source src="/projects/tcgme/LottieAnimations.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Token Optimization</h3>
              <p>Smart image transformations to minimize API token usage while generating accurate captions</p>
            </div>
          </div>
        </div>

        {/* Technical Challenges */}
        <div className="challenges-section">
          <h2>Technical Challenges</h2>
          <div className="challenge-list">
            <div className="challenge-item">
              <div className="challenge-number">01</div>
              <div className="challenge-content">
                <h3>Fast Image Processing</h3>
                <p>Implementing efficient image processing to generate cards without long wait times</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">02</div>
              <div className="challenge-content">
                <h3>Efficient Storage</h3>
                <p>Implemented an efficient storage system to store the cards captions and the path user card image from their camera roll</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">03</div>
              <div className="challenge-content">
                <h3>API Token Optimization</h3>
                <p>Finding the right image transformations to create quality cards with minimal API usage</p>
              </div>
            </div>
          </div>
        </div>
        

    </div>
  );
};

export default TcgMePage;
